import { AxiosError } from 'axios';

export const AXIOS_ERROR_CODE_MAP = new Map([
  [AxiosError.ERR_NETWORK, 'A01'],
  [AxiosError.ETIMEDOUT, 'A02'],
  [AxiosError.ECONNABORTED, 'A03'],
  [AxiosError.ERR_BAD_REQUEST, 'A04'],
  [AxiosError.ERR_BAD_RESPONSE, 'A05'],
]);

export const MUTED_ERR_SETS = new Set([
  '/gw-api/data-awesome/coin/latest/rate/list',
  '/gw-api/gateway/token/renew',
  '/gw-api/ds/pairs',
  '/gw-api/ping',
  '/gw-api/content/front/lowCode/batchQueryData',
  '/gw-api/user-center/settings/communal/forbidden/country/get',
  '/gw-api/ds/find_coin_invisible',
  '/gw-api/user-center/current-ip',
  '/gw-api/buy-sell-crypto/global-switch',
  '/gw-api/user-center/settings/forbidden/country',
  '/gw-api/user-center/settings/forbidden/ip/country',
  '/gw-api/ds/market-coin',
  '/gw-api/user-center/user/ext/lang',
]);

// 老版本语言的映射关系
export const LOCALE_MAP = new Map([
  ['en-US', 'en'],
  ['zh-CN', 'cn'],
  ['ja-JP', 'jp'],
  ['vi-VN', 'vn'],
  ['ru-RU', 'ru'],
  ['tr-TR', 'tr'],
  ['es-ES', 'es'],
  ['pt-BR', 'br'],
  ['ko-KR', 'kr'],
]);

// 老版本的反向映射关系 - 跟合约保持一致，为了导航条能引用的到
export const REVERSE_LOCALE_MAP = new Map([
  ['en', 'en-US'],
  ['br', 'pt-BR'],
  ['kr', 'ko-KR'],
  ['ru', 'ru-RU'],
  ['es', 'es-ES'],
  ['tr', 'tr-TR'],
  ['cn', 'zh-CN'],
  ['jp', 'ja-JP'],
  ['vn', 'vi-VN'],
]);

/**
 * 原则上，每一个语言都需要配置过，所以这里维护一个列表
 * 用来校验是否是有效的语言类型
 */
export const CONFIG_LOCALES_SET = new Set([
  'en-US',
  'pt-BR',
  'ko-KR',
  'ru-RU',
  'es-ES',
  'tr-TR',
  'zh-CN',
  'zh-TW',
  'ja-JP',
  'vi-VN',
  'de-DE',
  'fr-FR',
  'nl-NL',
  'uk-UA',
  'ar',
  'en-AU', // 硬编码添加语言
]);

// 默认标准语言
export const DEFAULT_LOCALE = 'en-US';
// 默认语言包语言
export const DEFAULT_I18N_LOCALE = 'en';
// 需要SEO的语言列表
export const SEO_LOCALES_ARRAY = ['en-US','es-ES','ja-JP','pt-BR','ru-RU','tr-TR','zh-CN'];

/**
 * 检查 locale 是否有效
 * @param maybeIsLocale: string
 * @returns
 */
export function checkLocale(maybeIsLocale: string) {
  return REVERSE_LOCALE_MAP.has(maybeIsLocale) || CONFIG_LOCALES_SET.has(maybeIsLocale);
}

function escapeLocale(pattern: string) {
  return pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * / -> /en-US
 * /en -> /en-US
 * /trade -> /trade/en-US
 * /trade/en -> /trade/en-US
 * /nft/jp/home -> nft/ja-JP/home
 **/
export function getRedirectPath(fullPath: string, targetLocale: string, replaceLocale: string, replace: boolean) {
  const pattern = new RegExp(`/${escapeLocale(targetLocale)}(?=/|$|\\?)`);
  let replacePath;
  if (replace) {
    replacePath = `/${replaceLocale}`;
  } else {
    replacePath = `/${(targetLocale ? targetLocale + '/' : '') + replaceLocale}`;
  }
  return fullPath.replace(pattern, replacePath);
}

export const NOTABENE_LOCALE_CONFIG_MAP = new Map([
  ['ar', 'ar'],
  ['de-DE', 'de-DE'],
  ['en', 'en-US'],
  ['es', 'es-ES'],
  ['fr-FR', 'fr-FR'],
  ['jp', 'ja-JP'],
  ['nl-NL', 'nl-NL'],
  ['br', 'pt-BR'],
  ['ru', 'ru-RU'],
  ['tr', 'tr-TR'],
  ['uk-UA', 'uk-UA'],
  ['vn', 'vi-VN'],
  ['cn', 'zh-CN'],
  ['zh-TW', 'zh-TW'],
])

export const NOTABENE_LOCALE_CONFIG_MAP_REVERSE = new Map([
  ['ar', 'ar'],
  ['de-DE', 'de-DE'],
  ['en-US', 'en'],
  ['es-ES', 'es'],
  ['fr-FR', 'fr-FR'],
  ['ja-JP', 'jp'],
  ['pt-BR', 'br'],
  ['nl-NL', 'nl'],
  ['ru-RU', 'ru'],
  ['tr-TR', 'tr'],
  ['uk-UA', 'uk-UA'],
  ['vi-VN', 'vn'],
  ['zh-CN', 'cn'],
  ['zh-TW', 'zh-TW'],
])

// 本次版本预置的法币单位
export const DEFAULT_CURRENCY = 'USD';
// CNY人民币
// USD美元
// JPY日元
// KRW韩元
// VND越南盾
// RUB卢布
// HKD港币
// TRY土耳其里拉
// BRL巴西雷亚尔
// EUR欧元
export const CURRENCY_MAP = new Map([
  [
    'USD',
    {
      name: 'USD',
      value: 'USD',
    },
  ],
  [
    'CNY',
    {
      name: 'CNY',
      value: 'CNY',
    },
  ],
  [
    'HKD',
    {
      name: 'HKD',
      value: 'HKD',
    },
  ],
  [
    'JPY',
    {
      name: 'JPY',
      value: 'JPY',
    },
  ],
  [
    'RUB',
    {
      name: 'RUB',
      value: 'RUB',
    },
  ],
  [
    'TRY',
    {
      name: 'TRY',
      value: 'TRY',
    },
  ],
  [
    'KRW',
    {
      name: 'KRW',
      value: 'KRW',
    },
  ],
  [
    'VND',
    {
      name: 'VND',
      value: 'VND',
    },
  ],
  [
    'BRL',
    {
      name: 'BRL',
      value: 'BRL',
    },
  ],
  [
    'EUR',
    {
      name: 'EUR',
      value: 'EUR',
    },
  ],
]);

// 2024-11-15 已迁移到frontend-share，该值日后删除，谨慎使用
// 法币符号
// www.xe.com/zh-CN/currencyconverter/convert/?Amount=1&From=KWD&To=USD
export const CURRENCY_UNIT_MAP = {
  USD: '$',
  ARS: 'ARS$',
  AED: 'د.إ',
  AUD: 'A$',
  AZN: '₼',
  BRL: 'R$',
  BGN: 'лв',
  BOB: '$b',
  BDT: '৳',
  CHF: 'CHF',
  CLP: '$',
  CRC: '₡',
  CNY: '¥',
  COP: 'COL$',
  CAD: 'C$',
  CZK: 'Kč',
  DKK: 'KR',
  DOP: 'RD$',
  EUR: '€',
  EGP: '£',
  GBP: '£',
  GEL: '₾',
  HUF: 'Ft',
  HRK: 'kn',
  HKD: 'HK$',
  INR: '₹',
  ILS: '₪',
  IDR: 'Rp',
  JPY: '¥',
  JOD: 'JD',
  KES: 'KSh',
  KRW: '₩',
  KWD: 'KD',
  KZT: '₸',
  LKR: '₨',
  MYR: 'RM',
  MAD: 'م.د.',
  MDL: 'lei',
  MXN: 'Mex$',
  NOK: 'kr',
  NAD: '$',
  NGN: '₦',
  NZD: 'NZ$',
  OMR: '﷼',
  PEN: 'S/.',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  QAR: '﷼',
  RUB: '₽',
  RON: 'lei',
  SAR: 'ر.س',
  SGD: 'S$',
  SEK: 'kr',
  TWD: 'NT$',
  THB: '฿',
  TRY: '₺',
  UAH: '₴',
  UYU: '$U',
  UZS: 'лв',
  UGX: 'USh',
  VND: '₫',
  VES: 'Bs',
  ZAR: 'R',
} as { [key: string]: string };

// RTL 语言列表
export const RTL_LOCAL_SET = new Set(['ar']);

// 需要连接现货行情ws的路由列表
export const USE_SPOT_WS_ROUTES = new Set([
  'trade-lang',
  'index-lang',
  'markets-lang',
  'crypto-lang',
  'inscription-zone-lang',
  'asset-spot-lang',
  // 点 logo 进首页，router.name 是 index，需要额外匹配
  'index',
]);

// 需要连接合约ws的路由列表
export const USE_FUTURES_WS_ROUTES = new Set([
  'index-lang',
  'crypto-lang',
  'agent2-lang',
  'futures-copy-trading-lang',
  'futures-copy-trading-detail-lang',
  // 点 logo 进首页，router.name 是 index，需要额外匹配
  'index',
]);